import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { BoUnpaidInvoicesRecoveryPage } from '../../../../../components/pages/unpaid-invoices-recovery/bo-unpaid-invoices-recovery-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

const searchSchema = type({ 'status?': "'success' | 'partialSuccess' | 'alreadyInProgress' | 'failure'" })

export const Route = createFileRoute('/bo/users/$userId_/unpaid-invoices/')({
  validateSearch: searchSchema,
  component: function Component() {
    const { userId } = Route.useParams()
    const { status } = Route.useSearch()
    return (
      <PermissionChecker requiredPermissions={['invoice.read']}>
        <BoUnpaidInvoicesRecoveryPage userId={userId} status={status} />
      </PermissionChecker>
    )
  },
})
